import React from "react";
import { Box, IconButton, Button, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

interface VenueOwnersListProps {
  type: "pending" | "accepted" | "rejected";
}

const StorageOwnersList: React.FC<VenueOwnersListProps> = ({ type }) => {
  const navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Switch demo" } };

  let rows: any[] = [];
  let columns: GridColDef<any>[] = [];

  if (type === "pending") {
    rows = [
      {
        id: 1,
        name: "John Doe",
        email: "john.doe@example.com",
        venue: "Storage A",
        date: "2024-07-26",
      },
      {
        id: 2,
        name: "Jane Smith",
        email: "jane.smith@example.com",
        venue: "Storage B",
        date: "2024-07-27",
      },
    ];
    columns = [
      {
        flex: 1,
        minWidth: 220,
        field: "name",
        headerName: "Name",
        editable: false,
        sortable: false,
        renderCell: (params) => (
          <div className="user_block click_action">
            <p>
              <b>{params.row.name}</b> <span>{params.row.email}</span>
            </p>
          </div>
        ),
      },
      {
        flex: 1,
        minWidth: 200,
        field: "venue",
        headerName: "Storage",
        editable: false,
        sortable: false,
      },
      {
        flex: 1,
        minWidth: 150,
        field: "date",
        headerName: "Date",
        editable: false,
        sortable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        flex: 1,
        minWidth: 150,
        field: "document",
        headerName: "Document",
        editable: false,
        sortable: false,
        align: "center",
        headerAlign: "center",
        renderCell: () => <Button className="btn sm btn_primary">View</Button>,
      },
      {
        minWidth: 130,
        field: "action",
        headerName: "Action",
        editable: false,
        sortable: false,
        renderCell: () => (
          <div className="table_actions v2">
            <Box>
              <IconButton>
                <img src="/static/images/eye_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => navigate("/manage-storage-owners/edit")}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton>
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        ),
      },
    ];
  } else if (type === "accepted") {
    rows = [
      {
        id: 1,
        name: "Alice Johnson",
        email: "alice.j@example.com",
        venue: "Venue C",
        bookings: 15,
      },
      {
        id: 2,
        name: "Bob Williams",
        email: "bob.w@example.com",
        venue: "Venue D",
        bookings: 25,
      },
    ];
    columns = [
      {
        flex: 1,
        minWidth: 220,
        field: "name",
        headerName: "Name",
        editable: false,
        sortable: false,
        renderCell: (params) => (
          <div className="user_block click_action">
            <p>
              <b>{params.row.name}</b> <span>{params.row.email}</span>
            </p>
          </div>
        ),
      },
      {
        flex: 1,
        minWidth: 200,
        field: "venue",
        headerName: "Storage",
        editable: false,
        sortable: false,
      },
      {
        flex: 1,
        minWidth: 150,
        field: "bookings",
        headerName: "Total Bookings",
        editable: false,
        sortable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        flex: 1,
        minWidth: 150,
        field: "commission",
        headerName: "Commission",
        editable: false,
        sortable: false,
        align: "center",
        headerAlign: "center",
        renderCell: () => (
          <Button className="btn sm btn_primary">Manage</Button>
        ),
      },
      {
        flex: 1,
        minWidth: 100,
        field: "recommended",
        headerName: "Recommended",
        editable: false,
        sortable: false,
        align: "center",
        headerAlign: "center",
        renderCell: () => <Switch {...label} defaultChecked />,
      },
      {
        flex: 1,
        minWidth: 100,
        field: "status",
        headerName: "Enable/Disable",
        editable: false,
        sortable: false,
        align: "center",
        headerAlign: "center",
        renderCell: () => <Switch {...label} defaultChecked />,
      },
      {
        minWidth: 130,
        field: "action",
        headerName: "Action",
        editable: false,
        sortable: false,
        renderCell: () => (
          <div className="table_actions v2">
            <Box>
              <IconButton>
                <img src="/static/images/eye_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => navigate("/manage-venue-storage-owners/edit")}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton>
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        ),
      },
    ];
  } else if (type === "rejected") {
    rows = [
      {
        id: 1,
        name: "Charlie Brown",
        email: "charlie.b@example.com",
        venue: "Venue E",
        reason: "Invalid documents",
      },
      {
        id: 2,
        name: "David Miller",
        email: "david.m@example.com",
        venue: "Venue F",
        reason: "Incomplete application",
      },
    ];
    columns = [
      {
        flex: 1,
        minWidth: 220,
        field: "name",
        headerName: "Name",
        editable: false,
        sortable: false,
        renderCell: (params) => (
          <div className="user_block click_action">
            <p>
              <b>{params.row.name}</b> <span>{params.row.email}</span>
            </p>
          </div>
        ),
      },
      {
        flex: 1,
        minWidth: 200,
        field: "venue",
        headerName: "Storage",
        editable: false,
        sortable: false,
      },
      {
        flex: 1,
        minWidth: 200,
        field: "reason",
        headerName: "Reason for Rejection",
        editable: false,
        sortable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        minWidth: 130,
        field: "action",
        headerName: "Action",
        editable: false,
        sortable: false,
        renderCell: () => (
          <div className="table_actions v2">
            <Box>
              <IconButton>
                <img src="/static/images/eye_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton>
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        ),
      },
    ];
  }

  return (
    <div className="sorting_table">
      <TableComponent columns={columns} rows={rows} />
    </div>
  );
};

export default StorageOwnersList;
